import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';
import { Column } from '../types';
import { getStickySx } from '../libs';
import { TableCell } from './TableCell';
import { mergeCellStyles } from './mergeCellStyles';

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  columns: Column<Data, Context>[];
}

export const TableHead = <Data extends Record<string, any>, Context extends any = any>({
  columns,
  context,
}: Props<Data, Context>) => (
  <Box className={clsx('listing-section', 'listing-header')}>
    {columns.map((column, columnIndex) => (
      <TableCell
        column={column}
        context={context}
        key={`${column.header}_${columnIndex}`}
        sx={{
          ...getStickySx(column, columns, columnIndex),
          ...mergeCellStyles(column?.cellStyles, column?.headerStyles),
        }}
      >
        {column.startIcon}

        {column.renderHeadCell ? (
          column.renderHeadCell({
            column,
            context,
            columns,
            columnIndex,
            existingColumnsTypes: columns.map(({ columnType }) => columnType).filter(Boolean) as string[],
          })
        ) : (
          <Typography variant="subtitle2" component="span">
            {column.header}
          </Typography>
        )}

        {column.endIcon}
      </TableCell>
    ))}
  </Box>
);
